import { render, staticRenderFns } from "./CoverQuestion.vue?vue&type=template&id=4bd937b8&scoped=true&"
import script from "./CoverQuestion.vue?vue&type=script&lang=ts&"
export * from "./CoverQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./CoverQuestion.vue?vue&type=style&index=0&id=4bd937b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd937b8",
  null
  
)

export default component.exports